var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-margin" }, [
    !_vm.diningName
      ? _c(
          "button",
          {
            staticClass: "btn-dining col row no-margin",
            on: {
              click: function($event) {
                return _vm.setPosSection("dining-options")
              }
            }
          },
          [
            _c("div", { staticClass: "col-10 text-left" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.nodiningselected")) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
      : _c(
          "button",
          {
            staticClass: "btn-dining col row no-margin",
            on: {
              click: function($event) {
                return _vm.setPosSection("dining-options")
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "col-10 text-left selected text-success" },
              [
                _c("i", {
                  staticClass: "fas fa-check",
                  staticStyle: { "margin-right": "3px" }
                }),
                _vm._v("\n      " + _vm._s(_vm.diningText) + "\n    ")
              ]
            ),
            _vm._v(" "),
            _vm._m(1)
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 text-right" }, [
      _c("i", { staticClass: "fas fa-angle-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 text-right" }, [
      _c("i", { staticClass: "fas fa-angle-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e95f922", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e95f922","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/mobile/common/DiningButton.vue
// module id = null
// module chunks = 